import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase';
import 'rxjs/add/operator/map';
import { NavParams } from 'ionic-angular/navigation/nav-params';
import { Storage } from '@ionic/storage';


@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  questionHtml: Observable<any[]>;
  answersList: Observable<any[]>;
  activeShow: number;
  activeQuizId: number;
  nickname: string = "MrNiceGuy";
  liveQuizData: any;
  liveQuizId: any;
  responseRef: AngularFireList<any>;
  status: number = 0; 
  statusMessages = ["Venter på quizmaster", "Gi ditt svar", "Ditt svar registrert"];
  statusMessage: string = ""  
  color: string = 'primary';
  statusRef: any;
  imageURL: any;
  quizMaster: boolean = false;
  isQuizMaster: boolean = false;
  gamePinImage: string;

  constructor(public navCtrl: NavController, private db: AngularFireDatabase, private navParams: NavParams, private storage: Storage) {
    this.activeShow = this.navParams.get('gameId');

    this.statusRef = db.object('show/' + this.activeShow + '/status').snapshotChanges().subscribe(action => {
      this.setStatus(action.payload.val())
    });
    this.db.object('show/' + this.activeShow).query.once("value").then(data => {
      this.gamePinImage = data.val().homeImage;
    })


    this.liveQuizId = db.object('show/' + this.activeShow + '/showQuizId').snapshotChanges().subscribe(action => {
      this.questionHtml = db.object('show/'+ this.activeShow + '/quiz/' + action.payload.val() + '/question').valueChanges();
      this.imageURL = db.object('show/'+ this.activeShow + '/quiz/' + action.payload.val() + '/imageURL').valueChanges();
      db.object('show/'+ this.activeShow + '/quizMaster').valueChanges().subscribe(val => {
        this.quizMaster = val as boolean;
      })
      this.answersList = db.list('show/'+ this.activeShow + '/quiz/' + action.payload.val() + '/answers').valueChanges();
      this.responseRef = db.list('showResponses/' + this.activeShow + '/' + action.payload.val());
      this.activeQuizId = action.payload.val();

      console.log('quiz'+ this.activeQuizId +'')

      storage.get('quiz'+ this.activeQuizId +'').then((val) => {
        let timeNow = new Date().getTime();
        let bufferTime = timeNow - (2*60*1000);
        console.log('buffertime ' + bufferTime);
        console.log('forrige svar ' + val);
        if (this.status != 0) {
          if(val > bufferTime){
            this.setStatus(2);
          } else {
            this.setStatus(1)
          }
        }
      });
      if (this.status == 2) {
        this.setStatus(1)
      }
    });

  }

  areYouQuizMaster() {
    if(this.quizMaster) {
      this.isQuizMaster = true;
    }
    console.log('quizMaster!!')
  }

  sendAnswer(answerData){

    console.log('send inn svar kl: ' + new Date().getTime())

    //set answer to local storage
    this.storage.set('quiz'+ this.activeQuizId +'',new Date().getTime());

    // send answer to firebase
    this.responseRef.push({nickname: this.nickname, aid: answerData.id, answer: answerData, timestamp: firebase.database.ServerValue.TIMESTAMP})

    this.setStatus(2);

  }

  setStatus(status: number){
    this.status = status;
    this.statusMessage = this.statusMessages[status];
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts